<template>
  <div id="app" :class="{ mobileView: isMobile }">
    <span v-if="isLoggedIn">
      <side-bar />
      <Main-header />
      <div class="main-content">
        <router-view />
        <div class="light version">{{ version }}</div>
        <Modal />
      </div>
    </span>
    <login-form v-else :version="version" />
  </div>
</template>

<script>
import MainHeader from "./components/MainHeader";
import SideBar from "./components/SideBar";
import version from "./constants/version";
import Modal from "./components/Modal";
import LoginForm from "./components/LoginForm";
import router from './router'
export default {
  name: "App",
  components: { MainHeader, SideBar, Modal, LoginForm },
  data: () => ({ version }),
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    isLoggedIn() {
      const getLsUser = localStorage.getItem("userData")
      let hasUser = false
      if(getLsUser){
        const data = JSON.parse(getLsUser)
        hasUser = data && data.username
      }
      return (this.$store.getters.user.username !== null || hasUser);
    },
    dataLoaded() {
      return this.$store.getters.dataLoaded;
    }
  },
  methods: {
    checkMobile() {
      const mobile = window.innerWidth <= 950;
      if (mobile && !this.isMobile) {
        this.$store.commit("updateIsMobile", true);
      }
      if (!mobile && this.isMobile) {
        this.$store.commit("updateIsMobile", false);
      }
    }
  },
  updated() {
    !this.$store.getters.moduleManager.loaded &&
      this.$store.dispatch('updateAllowedModulesList')
  },
  mounted() {
    this.checkMobile();
    if (this.isLoggedIn) {
      !this.dataLoaded && this.$store.dispatch("loadData")
    } else {
      router.push("/");
    }
    window.addEventListener("resize", this.checkMobile);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkMobile);
  }
};
</script>

<style lang="scss">
@import "./styles/colors.scss";
@import "./styles/vars.scss";
#app {
  position: relative;
}
.main-content {
  padding-bottom: 45px;
  position: relative;
  min-height: calc(100vh - #{$header-height});
  background-color: $mediumGray;
  width: calc(100% - #{$side-bar-width});
  margin-left: $side-bar-width;
  transition: all 0.3s;
}
.mobileView .main-content {
  z-index: 2;
  width: 100%;
  margin-left: 0;
}
.version {
  font-size: .75rem;
  margin: 50px 5% 0 5%;
  padding-top: 20px;
  position: absolute;
  bottom: 0;
  width: 90%;
  padding-bottom: 10px;
  text-align: right;
}
.page-title {
  font-size: 1.5rem;
  padding: 0;
  padding-top: 28px;
  margin: 0;
  color: $darkBlue;
}
</style>
